import { getDropdownLabelsFromSelectArray } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { endpoint } from "views/pages/manage/common/constant";
import { dropdownMapping } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";


export const getDropdowns = async () => {
    const dropdown = await Promise.all([
        dropdownMapping(
            endpoint.businessArea.getAllActiveV2,
            "businessAreaDispValue",
            "id",
            "businessAreaDesc"
        )
    ]);
    return {
        businessArea: dropdown[0],
    };
}


export const FILTER__FORM_FIELDS_GLOBAL = {
    invoiceNumber: "",
    businessArea: "",
    applicationId: "",
    psid: "",
    fromDate: "",
    toDate: "",
    thirdPartyStatus: []
};


export const hardcodeDropdown = {
    thirdPartyStatus: [
        {
            label: `SUCCESS`,
            value: 'SUCCESS'
        },
        {
            label: `FAILED`,
            value: 'FAILED'
        },
    ]
}

export const getFilterReqObj = (filters = {}, invoiceType = "") => {
    const { businessArea, thirdPartyStatus } = filters;
    const reqObj = {
        ...filters,
        gstType: invoiceType || "",
        businessArea: getDropdownLabelsFromSelectArray(businessArea),
        thirdPartyStatus: thirdPartyStatus?.value ? [thirdPartyStatus?.value] : []
    }
    return reqObj;
}

export const qrCodeMonitorPermission = [];